import React from 'react'
import styled, {keyframes} from 'styled-components'
import {KeyboardArrowDown, Cached, Clear} from '@material-ui/icons'
import {MenuItem, Menu, TextField, Snackbar} from '@material-ui/core'
import {getLinkedOptions, filterList} from 'utils/api'

const Value = styled.span`
	display: flex;
	align-items: center;
	justify-content: space-between;
	cursor: pointer;
	height: 30px;
	font-size: 16px;
`

const Underline = styled.div`
	transform: scaleX(0);
	transition: transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms;
	border-bottom: 2px solid;

	${props => props.invalid && `
		{
			border-bottom: 2px solid #f44336;
			transform: scaleX(1);
		}
	`}
`

const Container = styled.div`
	box-sizing: border-box;
	position: relative;
	margin-bottom: 28px;

	&:before {
		content: '';
		position: absolute;
		left: 0;
		right: 0;
		bottom: 0;
		border-bottom: 1px solid rgba(0, 0, 0, 0.42);
	}

	:hover {
		&:before {
			border-bottom: 2px solid #4a4a4a;
		}
	}
`

const Label = styled.div`
	font-weight: 700;
	font-size: 13.5px;
	line-height: 1;
	margin-bottom: 5px;
`

const Icons = styled.div`
	color: rgba(0, 0, 0, 0.54);
	display: flex;
	align-items: center;
`

const rotating = keyframes`
	from {
		transform: rotate(0deg);
	}

	to {
		transform: rotate(360deg);
	}
`

const Loading = styled(Cached)`
	&& {
		display: block;
		font-size: 22px;
		margin: 0 auto;
		padding: 4px;
		animation: ${rotating} 1s linear infinite;
	}
`

const Search = styled(TextField)`
	&& {
		padding: 10px 16px;
		width: 100%;
		box-sizing: border-box;
		position: sticky;
		top: 0;
		background: #FFF;
		z-index: 1;
	}
`

class Linked extends React.Component {
    constructor(props) {
        super(props)

        this.options = []
		this.filteredOptions = []
		
        this.state = {
            open: false,
            valueText: props.valueText,
            pattern: '',
            isLoading: false,
			error: false
        }
    }

    handleClick = () => {
		this.setState({
            isLoading: true
        })

		getLinkedOptions(this.props.fieldId, this.props.record)
			.then(
				(result) => {
					this.options = [...result]
					this.filteredOptions = [...result]

					this.setState({
						isLoading: false,
						open: true
					})
				},
				(error) => {
					console.log(error)
					this.setState({
						isLoading: false,
						error: true
					})
				}
			)
    }

    handleClose = () => {
        this.setState({
            open: false,
			pattern: ''
        })
    }

    handleDelete = (e) => {
		e.stopPropagation()
		this.setState({valueText: ''})
    	this.props.handleChange('c' + this.props.relation, [])
        this.handleClose()
    }

    handleSelect = (e) => {
		const text = this.options.find(item => item.id === e.target.value).name
		this.setState({valueText: text})
        this.props.handleChange('c' + this.props.relation, [e.target.value])
        this.handleClose()
    }

	handleChange = (e) => {
		this.filteredOptions = filterList(this.options, e.target.value, ['name'])
		this.setState({pattern: e.target.value})
	}

    render() {
        const {label, defaultValue, invalid, fieldId} = this.props

        return (
            <Container ref={el => this.anchorEl = el} data-id={invalid ? fieldId : null}>
				<Label dangerouslySetInnerHTML={{__html: label}} />
				{this.state.isLoading ?
                    <Loading /> :
					<Value onClick={this.handleClick}>
						<span>
							{this.state.valueText}
						</span>
						<Icons>
							{defaultValue &&
								<Clear
									style={{fontSize: '15px', marginRight: '5px'}}
									onClick={this.handleDelete}
								/>
							}
							{!this.props.readonly &&
								<KeyboardArrowDown
									// style={this.state.isLoading ?
									//     {display: 'none'} : this.state.open ?
									//     {transform: 'rotate(180deg)'} :
									//     {}
									// }
								/>
							}
						</Icons>
					</Value>
				}
				{this.state.open &&
					<Menu
						anchorEl={this.anchorEl}
						open={this.state.open}
						getContentAnchorEl={null}
						onClose={this.handleClose}
						autoFocus={false}
						anchorOrigin={{
							vertical: 'bottom',
							horizontal: 'center',
						}}
						transformOrigin={{
							vertical: 'top',
							horizontal: 'center',
						}}
						PaperProps={{
							style: {
								maxHeight: '300px',
								width: '50%',
							}
						}}
						MenuListProps={{
							style: {
								paddingTop: 0
							}
						}}
					>
						<Search value={this.state.pattern} onChange={this.handleChange} onKeyDown={(e) => e.stopPropagation()} />
						{this.filteredOptions.map(option =>
							<MenuItem key={option.id}
								selected={option.id === defaultValue}
								onClick={this.handleSelect}
								value={option.id}
							>
								{option.name}
							</MenuItem>
						)}
					</Menu>
				}
				<Snackbar
					anchorOrigin={{
						vertical: 'bottom',
						horizontal: 'center'
					}}
					autoHideDuration={2000}
					open={this.state.error}
					onClose={() => this.setState({error: false})}
					message="Something goes wrong! Please, try again later"
				/>
				<Underline invalid={invalid} />
            </Container>
        )
    }
}

export default Linked
